import { GridLegacy } from "@mui/material";
import Editor from "../../../Editor/Editor";
import React, { useContext, useEffect } from "react";
import { HandleSamples } from "../../Tools/Requests";
import { SmetaModalsButtonsContext } from "../../Tools/modalManager";

export default function DialogSaveSample({ props }) {
  const [value, setValue] = React.useState(props.value !== undefined ? props.value : "");

  const setButtons = useContext(SmetaModalsButtonsContext);

  useEffect(() => {
    if (props.hiddenButton) return;
    const modalButtons: { [key: number]: { label: string; onClick?: () => void } } = {};
    if (!props.buttons || Number(props.buttons) & 1) {
      modalButtons[1] = { label: "Сохранить", onClick: onSelect };
    }
    setButtons?.(modalButtons);
  }, [setButtons, value]);

  function onEdit(data: { value: string }) {
    setValue(data.value);
  }
  function onSelect() {
    HandleSamples({ Path: props.Path, Command: "save", Name: value });
  }
  return (
    <GridLegacy
      id={"mainElement"}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      style={{ position: "relative", height: "100%" }}
    >
      <GridLegacy
        item
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        <GridLegacy container direction="row" justifyContent="flex-start" alignItems="center">
          <GridLegacy style={{ width: "135px" }} item>
            Название шаблона:
          </GridLegacy>
          <GridLegacy
            style={{
              width: "calc(100% - 135px)",
              backgroundColor: "#FFFFFF",
              border: "1px solid #eeeeee",
              height: "27px",
            }}
            item
          >
            <Editor value={value} onEdit={onEdit} />
          </GridLegacy>
        </GridLegacy>
      </GridLegacy>
    </GridLegacy>
  );
}
